#@import Booking.Views.PickerElement
#@import Booking.Presenters.Option
#@export Booking.Views.Option

class Booking.Views.Option extends Booking.Views.PickerElement

  presenter: Booking.Presenters.Option

  templateName: 'option'

  tagName: 'li'

  select: ->
    # Prevent default behavior if option is sold out
    return if @model.isSoldOut()

    Booking.Views.PickerElement::select.apply this, arguments
